import { render, staticRenderFns } from "./ClientReferenceListItem.vue?vue&type=template&id=36760547&"
import script from "./ClientReferenceListItem.vue?vue&type=script&lang=js&"
export * from "./ClientReferenceListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports